import { render, staticRenderFns } from "./visible.vue?vue&type=template&id=28000a76&scoped=true&"
var script = {}
import style0 from "./visible.vue?vue&type=style&index=0&id=28000a76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28000a76",
  null
  
)

export default component.exports